import { FeatureTypes } from '../enums/feature-types';
import { FeatureStates } from '../enums/feature-states';

export class FeatureData {
    constructor (
        public FeatureType: FeatureTypes,
        public Data: any,
        public State: FeatureStates = FeatureStates.Default,
    ) {
        
    }
}